import { render, staticRenderFns } from "./SysBasic.vue?vue&type=template&id=b5bb5d10&scoped=true"
import script from "./SysBasic.vue?vue&type=script&lang=js"
export * from "./SysBasic.vue?vue&type=script&lang=js"
import style0 from "./SysBasic.vue?vue&type=style&index=0&id=b5bb5d10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bb5d10",
  null
  
)

export default component.exports